import Vue from 'vue';
import Autocomplete from '@trevoreyre/autocomplete-vue'
import TrackEvent from '../../utils/tracking';
export default Vue.component('waste-type-size-finder', {
    components: {
        Autocomplete
    },
    data: function () {
        return {
            products: [],
            selected: null,
        };
    },
    methods:{
        search(input) {
            this.inputValue = input;
            if (input.length < 1) { 
                return [];
            }
            
            return this.products.filter(product => {
                return product.name
                    .toLowerCase()
                    .startsWith(input.toLowerCase())
            });
        },
        getResultValue(result) {
            return result.name;
        },

        resetContentBlocks() {
            var supermarket = $("#ewasteinleverwijzer01supermarkt");
            var electronica = $("#ewasteinleverwijzer02electronicawinkelsentuincentra");
            var megastores = $("#ewasteinleverwijzer03megastoresenbouwmarkten");
            var milieustraat = $("#ewasteinleverwijzer04bijdegemeente");
            
            // hide all blocks
            supermarket.hide();
            electronica.hide();
            megastores.hide();
            milieustraat.hide();             
        },

        updateContentBlocks() {
            var supermarket = $("#ewasteinleverwijzer01supermarkt");
            var electronica = $("#ewasteinleverwijzer02electronicawinkelsentuincentra");
            var megastores = $("#ewasteinleverwijzer03megastoresenbouwmarkten");
            var milieustraat = $("#ewasteinleverwijzer04bijdegemeente");
            
            // hide all blocks
            this.resetContentBlocks();
            
            if(!this.selected) {                
                return;
            }

            // milieustraat is always visible
            milieustraat.show();

            switch(this.selected.wasteType) {
                case 1: // groot
                    megastores.show();
                    break;
                case 6: // middelgroot
                    megastores.show();
                    electronica.show();
                    break;
                case 4: // lampen
                case 2: // klein        
                case 7: // batterijen   
                case 0: // all
                    megastores.show();
                    electronica.show();
                    supermarket.show();
                    break;
            }
        },
        onSelectSize(e) {
            const name = e.target.dataset.name;

            this.selected = {
                name: name,
                wasteType: parseInt(e.target.value),
                isGeneric: true
            }

            TrackEvent({
                hitType: 'event',
                eventCategory: 'Inleverwijzer',
                eventAction: 'Select size',
                eventLabel: name
            });
        },
        submit(result) {
            // No result from autocomplete, manual input
            if (!result) {
                // Check if we have a match
                result = this.products.filter(product => {
                    return product.name
                        .toLowerCase() === this.inputValue
                });
                // no match, default value
                if (!result.length) {
                    this.selected = {
                        name: 'Apparaat',
                        wasteType: 0,
                        isGeneric: true
                    }
                } else {
                    this.selected = {
                        name: result[0].name,
                        wasteType: parseInt(result[0].wasteType.id),
                        isGeneric: false,
                        returnCleanCategory: result[0].returnCleanCategory
                    }
                }
            } else {
                this.selected = {
                    name: result.name,
                    wasteType: parseInt(result.wasteType.id),
                    isGeneric: false,
                    returnCleanCategory: result.returnCleanCategory
                }
            }

            TrackEvent({
                hitType: 'event',
                eventCategory: 'Inleverwijzer',
                eventAction: 'Select product',
                eventLabel: this.selected.name
            });

            this.updateContentBlocks();
        },
        reset() {
            this.selected = null;

            TrackEvent({
                hitType: 'event',
                eventCategory: 'Inleverwijzer',
                eventAction: 'Reset'
            });
        }
    }
});

